export default __webpack_public_path__ + "static/media/me_svg.c42ed83f.svg";